<app-slide-overlay-header
  [canShare]="hasEntitiesWriteAccess"
  [canArchive]="hasEntitiesWriteAccess"
  [enableTags]="isRegularUser"
  [canDelete]="hasEntitiesWriteAccess"
  (share)="confirmShareDialog()"
  [canSend]="isCrossOrgSharingEnabled && isCrossOrgSharingLocationEnabled && hasEntitiesWriteAccess"
  (send)="confirmSendDialog()"
  [title]="title()"
  icon="location_on"
></app-slide-overlay-header>
<app-slide-overlay-content #slideOverlayContent (menuItemChanged)="onMenuItemChanged($event)">
  <ng-template
    [overlay-menu-tab]="overlayTabEnum.DETAILS"
    appSlideOverlayMenuItem
    overlay-menu-icon="info"
    [overlay-menu-title]="menuItems().get(overlayTabEnum.DETAILS).title"
  >
    <app-form-field-group [name]="mainInformationText">
      <app-location-overlay-main-information
        #informationView
        (reloadOrganisations)="reloadOrganisations($event)"
        [countryOptions]="countryOptions()"
        [formGroup]="formGroup"
        [isEditing]="isEditing()"
        [organisationOptions]="organisationOptions()"
        [element]="element"
      ></app-location-overlay-main-information>
    </app-form-field-group>
    <app-form-field-group [name]="translations.address">
      <app-location-overlay-address-checkbox
        [allOrganisations]="allOrganisations()"
        [countryOptions]="countryOptions()"
        [formGroup]="formGroup"
        group-name-content
      ></app-location-overlay-address-checkbox>

      <app-location-overlay-address
        [countryOptions]="countryOptions()"
        [formGroup]="formGroup"
      ></app-location-overlay-address>
    </app-form-field-group>
    @if (visibleCustomFields?.length) {
      <app-form-field-group [name]="additionalInformationText">
        <app-custom-fields-edit
          [elementCustomFields]="element?.customFields"
          [formGroup]="formGroup"
          [enableViewMode]="true"
          [visibleCustomFields]="visibleCustomFields"
        ></app-custom-fields-edit>
      </app-form-field-group>
    }
    @if (element && isRegularUser && overlay.viewMode()) {
      <app-form-field-group [name]="recordDetailsText">
        <app-record-details [element]="element"></app-record-details>
      </app-form-field-group>
    }
  </ng-template>
  <ng-template
    [overlay-menu-disabled]="!menuItems().get(overlayTabEnum.GPS_DATA).isEnabled"
    [overlay-menu-indicator]="gpsIndicator"
    [overlay-menu-buttons-template]="gpsController"
    [overlay-menu-show-save-button]="!overlay.viewMode()"
    [overlay-menu-show-edit-button]="false"
    [overlay-menu-title]="menuItems().get(overlayTabEnum.GPS_DATA).title"
    [overlay-menu-tab]="overlayTabEnum.GPS_DATA"
    appSlideOverlayMenuItem
    overlay-menu-svg-icon="map"
  >
    <app-location-overlay-gps
      #locationGpsView
      [geojson]="geojsonFile()"
      [formGroup]="formGroup"
      [coordinatesFormGroups]="coordinatesFormGroups"
      [showCoordinateForm]="shouldShowCoordinatesForm()"
      [isEditing]="isEditing()"
      (removeMap)="onRemoveMap()"
      (editGeojsonCoordinates)="showCoordinateForm.set(true)"
      [canEditCoordinates]="canEditCoordinates()"
      (addGpsData)="addGpsData()"
    ></app-location-overlay-gps>
  </ng-template>
  <ng-template #gpsController>
    @if (isRecordActive && hasEntitiesWriteAccess) {
      @if (element.geoLocation && overlay.viewMode()) {
        <app-button
          [disabled]="overlay.loading()"
          type="ghost"
          (pressed)="switchToEditMode()"
          i18n="@@action.edit"
        >
          Edit
        </app-button>
      } @else if (overlay.viewMode()) {
        <app-button [disabled]="overlay.loading()" type="ghost" (pressed)="addGpsData()">
          <mat-icon class="action-icon" icon-left>add</mat-icon>
          <ng-container i18n="@@action.add">Add</ng-container>
        </app-button>
      } @else {
        <app-button
          [disabled]="overlay.loading()"
          type="ghost"
          (pressed)="cancelEditing()"
          i18n="@@action.cancel"
        >
          Cancel
        </app-button>
      }
    }
  </ng-template>
  <ng-template #gpsIndicator>
    @if (formGroup?.controls["geoLocation"]?.value) {
      <div class="gps-indicator"></div>
    }
  </ng-template>
  <ng-template
    *ngIf="!menuItems().get(overlayTabEnum.LINKED_LOCATIONS).isHidden"
    [overlay-menu-buttons-template]="linkedController"
    [overlay-menu-disabled]="!menuItems().get(overlayTabEnum.LINKED_LOCATIONS).isEnabled"
    [overlay-menu-indicator]="locationOverlay.linkedLocationCounter()"
    [overlay-menu-show-save-button]="false"
    [overlay-menu-title]="menuItems().get(overlayTabEnum.LINKED_LOCATIONS).title"
    [overlay-menu-tab]="overlayTabEnum.LINKED_LOCATIONS"
    appSlideOverlayMenuItem
    overlay-menu-svg-icon="linked-locations"
  >
    <app-location-overlay-links
      #linkedLocationView
      (changes)="onHasSaved()"
      [countryOptions]="countryOptions()"
      [allLocationTypes]="allLocationTypes"
      [isReadOnly]="isRecordArchived"
      [locationId]="recordId"
    ></app-location-overlay-links>
  </ng-template>
  <ng-template #linkedController>
    @if (!overlay.contentRightSidePanel() && isRecordActive && hasEntitiesWriteAccess) {
      <app-button
        (pressed)="overlay.openSideMenu(linkedLocationView?.linkedSideMenu)"
        [disabled]="overlay.loading()"
        type="ghost"
      >
        <mat-icon class="action-icon" icon-left>add</mat-icon>
        <ng-container i18n="@@action.add">Add</ng-container>
      </app-button>
    }
  </ng-template>
  <ng-template
    [overlay-menu-buttons-template]="certificateController"
    [overlay-menu-disabled]="!menuItems().get(overlayTabEnum.CERTIFICATES).isEnabled"
    [overlay-menu-indicator]="locationOverlay.certificateCounter()"
    [overlay-menu-show-save-button]="false"
    [overlay-menu-title]="menuItems().get(overlayTabEnum.CERTIFICATES).title"
    [overlay-menu-tab]="overlayTabEnum.CERTIFICATES"
    appSlideOverlayMenuItem
    overlay-menu-icon="verified_user"
  >
    <app-overlay-certificate-attachments
      #certificateView
      (changes)="onHasSaved()"
      [attachmentTargetId]="element?.id"
      [attachmentTargetType]="attachmentTargetEnum.LOCATION"
      [isReadOnly]="isRecordArchived"
      [overlayService]="locationOverlay"
    ></app-overlay-certificate-attachments>
  </ng-template>
  <ng-template #certificateController>
    @if (!overlay.contentRightSidePanel() && isRecordActive && hasEntitiesWriteAccess) {
      <app-button
        (pressed)="overlay.openSideMenu(certificateView?.attachmentsRightMenu)"
        [disabled]="overlay.loading()"
        type="ghost"
      >
        <mat-icon class="action-icon" icon-left>add</mat-icon>
        <ng-container i18n="@@action.add">Add</ng-container>
      </app-button>
    }
  </ng-template>
  <ng-template
    [overlay-menu-buttons-template]="documentController"
    [overlay-menu-disabled]="!menuItems().get(overlayTabEnum.DOCUMENTS).isEnabled"
    [overlay-menu-indicator]="documentLinkedCounter"
    [overlay-menu-show-save-button]="false"
    [overlay-menu-title]="menuItems().get(overlayTabEnum.DOCUMENTS).title"
    [overlay-menu-tab]="overlayTabEnum.DOCUMENTS"
    appSlideOverlayMenuItem
    overlay-menu-icon="docs"
  >
    <app-overlay-document-attachments
      #documentView
      (changes)="onHasSaved()"
      [attachmentTargetId]="element?.id"
      [attachmentTargetType]="attachmentTargetEnum.LOCATION"
      [isReadOnly]="isRecordArchived"
      [overlayService]="locationOverlay"
    ></app-overlay-document-attachments>
  </ng-template>
  <ng-template #documentController>
    @if (!overlay.contentRightSidePanel() && isRecordActive && hasEntitiesWriteAccess) {
      <app-button
        (pressed)="overlay.openSideMenu(documentView?.attachmentsRightMenu)"
        [disabled]="overlay.loading()"
        type="ghost"
      >
        <mat-icon class="action-icon" icon-left>add</mat-icon>
        <ng-container i18n="@@action.add">Add</ng-container>
      </app-button>
    }
  </ng-template>
  <ng-template #documentLinkedCounter>
    @if (locationOverlay.documentCounter() === null) {
      <div class="indicator">
        <mat-icon class="rotate-animation loading-icon">cached</mat-icon>
      </div>
    } @else {
      @if (locationOverlay.hasMissingDocumentTypes()) {
        <div class="indicator no-background">
          <mat-icon class="warn-icon" svgIcon="alert-triangle" [tp]="translations.missingTypesTp" />
        </div>
      }
      @if (locationOverlay.documentCounter()) {
        <div class="indicator">
          {{ locationOverlay.documentCounter() }}
        </div>
      }
    }
  </ng-template>
  <ng-template
    *ngIf="!menuItems().get(overlayTabEnum.ANALYSES).isHidden"
    [overlay-menu-buttons-template]="analysisController"
    [overlay-menu-disabled]="!menuItems().get(overlayTabEnum.ANALYSES).isEnabled"
    [overlay-menu-indicator]="analysesTableService.analysisCounter()"
    [overlay-menu-show-save-button]="false"
    [overlay-menu-title]="menuItems().get(overlayTabEnum.ANALYSES).title"
    [overlay-menu-tab]="overlayTabEnum.ANALYSES"
    appSlideOverlayMenuItem
    overlay-menu-svg-icon="analysis"
  >
    <app-analyses-table tableContainerClass="field-group-container"></app-analyses-table>
  </ng-template>
  <ng-template #analysisController>
    @if (isRecordActive && hasEntitiesWriteAccess) {
      <app-button (pressed)="analysesTableService.add()" type="ghost">
        <mat-icon class="action-icon" icon-left>add</mat-icon>
        <ng-container i18n="@@action.add">Add</ng-container>
      </app-button>
    }
  </ng-template>
  @if (!menuItems().get(overlayTabEnum.SHARES).isHidden && locationOverlay.shareCounter()) {
    <ng-template
      [overlay-menu-disabled]="!menuItems().get(overlayTabEnum.SHARES).isEnabled"
      [overlay-menu-show-edit-button]="false"
      [overlay-menu-show-save-button]="false"
      [overlay-menu-title]="menuItems().get(overlayTabEnum.SHARES).title"
      [overlay-menu-indicator]="locationOverlay.shareCounter()"
      [overlay-menu-tab]="overlayTabEnum.SHARES"
      appSlideOverlayMenuItem
      overlay-menu-icon="share"
    >
      <article class="field-group-container">
        @if (isLoadingShares()) {
          <app-loader></app-loader>
        } @else {
          <app-shares-table
            [isInOverlay]="true"
            [shares]="locationOverlay.shares()"
            (deleted)="this.onShareDeleted()"
          ></app-shares-table>
        }
      </article>
    </ng-template>
  }
  <ng-template
    *ngIf="!menuItems().get(overlayTabEnum.RISK_ASSESSMENT_REPORTS).isHidden"
    [overlay-menu-tab]="overlayTabEnum.RISK_ASSESSMENT_REPORTS"
    appSlideOverlayMenuItem
    overlay-menu-icon="select_check_box"
    [overlay-menu-title]="menuItems().get(overlayTabEnum.RISK_ASSESSMENT_REPORTS).title"
    [overlay-menu-buttons-template]="riskAssessmentController"
    [overlay-menu-show-edit-button]="false"
    [overlay-menu-show-save-button]="false"
    [overlay-menu-indicator]="locationOverlay.reportsCounter()"
    [overlay-menu-disabled]="!menuItems().get(overlayTabEnum.RISK_ASSESSMENT_REPORTS).isEnabled"
  >
    <app-overlay-risk-assessment-reports
      #riskAssessmentsView
      [activeOrganisationId]="activeOrganisationId"
      [overlayService]="locationOverlay"
      [recordUri]="entityUri"
      [resourceType]="templateResourceType"
      [relatedRecords]="riskAssessmentReportRelatedRecords().data"
      [isLoading]="riskAssessmentReportRelatedRecords().isLoading"
    />
  </ng-template>
  <ng-template #riskAssessmentController>
    @if (isRecordActive && hasEntitiesWriteAccess) {
      <app-button
        type="ghost"
        [disabled]="overlay.loading()"
        (pressed)="riskAssessmentsView.openDialog()"
      >
        <mat-icon class="action-icon" icon-left>add</mat-icon>
        <ng-container i18n="@@action.add">Add</ng-container>
      </app-button>
    }
  </ng-template>
  <ng-template
    *ngIf="!menuItems().get(overlayTabEnum.COMMENTS).isHidden"
    [overlay-menu-disabled]="!menuItems().get(overlayTabEnum.COMMENTS).isEnabled"
    [overlay-menu-indicator]="locationOverlay.commentCounter()"
    [overlay-menu-show-edit-button]="false"
    [overlay-menu-show-save-button]="false"
    [overlay-menu-title]="menuItems().get(overlayTabEnum.COMMENTS).title"
    [overlay-menu-tab]="overlayTabEnum.COMMENTS"
    appSlideOverlayMenuItem
    overlay-menu-icon="chat_bubble"
  >
    <article class="field-group-container">
      <app-comments
        (added)="onCommentAdded(locationOverlay)"
        (deleted)="onCommentDeleted(locationOverlay)"
        [entityId]="element?.id"
        [entityType]="entityType"
      ></app-comments>
    </article>
  </ng-template>
</app-slide-overlay-content>
